import React from 'react';

import {
    IconAptos,
    IconDollar,
    IconEthereum,
    IconEthereumColor,
    IconEthereumDark,
    IconEthereumLight,
    IconMatic,
} from '@pkg/assets/icons/currency';
import { type BaseCurrencyType } from '@pkg/types';

// Theme is not supported for all `currency` types.
export type CurrencyIconTheme = 'color' | 'dark' | 'light' | 'glyph';

export interface CurrencyIconProps {
    currency: BaseCurrencyType;
    theme?: CurrencyIconTheme;
}

function getAsset(currency: BaseCurrencyType, theme?: CurrencyIconTheme) {
    switch (currency) {
        case 'apt': {
            return IconAptos;
        }
        case 'eth': {
            switch (theme) {
                case 'color':
                    return IconEthereumColor;
                case 'dark':
                    return IconEthereumDark;
                case 'light':
                    return IconEthereumLight;
                default:
                    return IconEthereum;
            }
        }
        case 'matic': {
            return IconMatic;
        }
        default: {
            return IconDollar;
        }
    }
}

export function CurrencyIcon({ currency, theme }: CurrencyIconProps) {
    const Asset = getAsset(currency, theme);
    return <Asset />;
}
